import { Validators } from '@angular/forms';

export const IntegerValidator = Validators.pattern('^[0-9]*$');

export const DateValidator = Validators.pattern(/^\d{2}\/\d{2}\/\d{4}$/);
